import { render, staticRenderFns } from "./InformForm.vue?vue&type=template&id=0d193d10&scoped=true"
import script from "./InformForm.vue?vue&type=script&lang=js"
export * from "./InformForm.vue?vue&type=script&lang=js"
import style0 from "./InformForm.vue?vue&type=style&index=0&id=0d193d10&prod&lang=scss&scoped=true"
import style1 from "./InformForm.vue?vue&type=style&index=1&id=0d193d10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d193d10",
  null
  
)

export default component.exports